/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SavedPromptRequestField } from './SavedPromptRequestField';
import {
    SavedPromptRequestFieldFromJSON,
    SavedPromptRequestFieldFromJSONTyped,
    SavedPromptRequestFieldToJSON,
} from './SavedPromptRequestField';

/**
 * 
 * @export
 * @interface PromptRequest
 */
export interface PromptRequest {
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    patient_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    document_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    template_id?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    context?: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    prompt: string;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    provider?: string;
    /**
     * 
     * @type {number}
     * @memberof PromptRequest
     */
    budget_tokens?: number;
    /**
     * 
     * @type {string}
     * @memberof PromptRequest
     */
    model?: string;
    /**
     * 
     * @type {Array<SavedPromptRequestField>}
     * @memberof PromptRequest
     */
    fields?: Array<SavedPromptRequestField>;
    /**
     * 
     * @type {boolean}
     * @memberof PromptRequest
     */
    include_main_context?: boolean;
}

/**
 * Check if a given object implements the PromptRequest interface.
 */
export function instanceOfPromptRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "prompt" in value;

    return isInstance;
}

export function PromptRequestFromJSON(json: any): PromptRequest {
    return PromptRequestFromJSONTyped(json, false);
}

export function PromptRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromptRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'patient_id': !exists(json, 'patient_id') ? undefined : json['patient_id'],
        'document_id': !exists(json, 'document_id') ? undefined : json['document_id'],
        'template_id': !exists(json, 'template_id') ? undefined : json['template_id'],
        'context': !exists(json, 'context') ? undefined : json['context'],
        'prompt': json['prompt'],
        'provider': !exists(json, 'provider') ? undefined : json['provider'],
        'budget_tokens': !exists(json, 'budget_tokens') ? undefined : json['budget_tokens'],
        'model': !exists(json, 'model') ? undefined : json['model'],
        'fields': !exists(json, 'fields') ? undefined : ((json['fields'] as Array<any>).map(SavedPromptRequestFieldFromJSON)),
        'include_main_context': !exists(json, 'include_main_context') ? undefined : json['include_main_context'],
    };
}

export function PromptRequestToJSON(value?: PromptRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'patient_id': value.patient_id,
        'document_id': value.document_id,
        'template_id': value.template_id,
        'context': value.context,
        'prompt': value.prompt,
        'provider': value.provider,
        'budget_tokens': value.budget_tokens,
        'model': value.model,
        'fields': value.fields === undefined ? undefined : ((value.fields as Array<any>).map(SavedPromptRequestFieldToJSON)),
        'include_main_context': value.include_main_context,
    };
}

